<style scoped>
    textarea:focus {
        outline-style: solid;
        outline-width: 0px;
    }
</style>
<script>

import Form from 'form-backend-validation';
import axios from 'axios';
import autosize from 'autosize';

export default {
    props: [
        'trainingId'
    ],

    data() {
        return {
            success: true,

            count: null,

            offset: 10,

            limit: 10,

            busy: false,

            discussions: [],

            loginForm: new Form({
                email: '',
                password: ''
            }, {
                resetOnSuccess: false,
            }),

            form: new Form({
                comment: ''
            }, {
                resetOnSuccess: false,
            }),
        };
    },

    mounted() {
        this.fetchDiscussions();

        autosize(this.$refs.commentArea);
    },

    methods: {

        async fetchDiscussions() {

            let data = await axios.get(`/api/comments/${this.trainingId}?offset=${this.offset}`)
                .catch(function(e){if(e.code!=='ECONNABORTED'){throw e;}});

            this.busy = false;

            this.offset = this.offset + this.limit;

            this.discussions = data.data.comments;
            this.count = data.data.count;
        },

        reset(event) {
            this.form.errors.clear(event.target.name);
            this.success = false;
        },

        onLogin(){
            this.loginForm.post(`/login`)
                .then(response => {
                    document.location.reload();
                });
        },

        onSubmit(){
            this.form.post(`/api/comments/${this.trainingId}`)
                .then(response => {
                    this.form.comment = '';
                    this.success = true;
                    autosize.update(this.$refs.commentArea);

                    this.fetchDiscussions();
                });
        },

        loadMore: function() {
            if (this.count !== null && this.count > this.discussions.length && ! this.busy) {
                this.busy = true;
                this.fetchDiscussions();
            }
            if (this.count === this.discussions.length) {
                const loadMore = document.getElementById("loadMore");
                loadMore.style.display = "none";
            }
        }
    }
}
</script>